export const goalRules = {
  goalName: [(v) => !!v || "Goal Name is required"],
  farmId: [
    (v) => !!v || "Farm / Segments is required",
    (v) => v !== "Choose farm or zone" || "Farm / Segments is required",
  ],
  goalSubject: [
    (v) => !!v || "Goal Subject is required",
    (v) => v !== "Set goal for?" || "Goal Subject is required",
  ],
  baseValue: [
    (v) => {
      if (!Number(v) && v != 0) {
        return "Base Value should be number";
      }
      return true
    },
  ],
  targetValue: [
    (v) => {
      if (!Number(v) && v != 0) {
        return "Target Value should be number";
      }
      return true
    },
  ],
};
